
import type { SVGProps } from 'react';
const SvgEditieren = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#editieren_svg__a)">
      <path
        fill="#263E6A"
        d="M1.537 22.463h1.65L18.392 7.256l-1.65-1.65L1.538 20.815zM21.683 6.151 17.84 2.326 19.697.47A1.53 1.53 0 0 1 20.818 0q.652 0 1.122.47l1.59 1.59q.47.47.479 1.113t-.461 1.113zm-1.106 1.114L3.842 24H0v-3.842L16.735 3.423zm-3.023-.848-.81-.81 1.65 1.65z"
      />
    </g>
    <defs>
      <clipPath id="editieren_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEditieren;
